import { RadioButtonValgModel } from '../../Shared/Scripts/Components/RadioButtonValg';
import VeilederVgsUrDto from '../Models/VeilederVgsUrDto';

const heltAr = 'b1-heltAr';
const host = 'b2-host';
const vaar = 'b3-var';

const map = {
    'b1-heltAr': 10,
    'b2-host': 5,
    'b3-var': 5,
};

const bValg: RadioButtonValgModel<VeilederVgsUrDto>[] = [
    { id: 'b1', value: heltAr, tekst: 'valgHeltAr' },
    { id: 'b2', value: host, tekst: 'valgHost' },
    { id: 'b3', value: vaar, tekst: 'valgVar' },
];

export default {
    b1_heltAr: heltAr,
    b2_host: host,
    b3_var: vaar,
    bValg,

    antallMnd: (semesterType: string): number => {
        return map[semesterType];
    },
};
